import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_PROJECTS_REQUEST,
  CREATE_PROJECT_REQUEST,
  UPDATE_PROJECT_REQUEST,
  DELETE_PROJECT_REQUEST,
  ASSIGN_USERS_TO_PROJECT_REQUEST,
  FETCH_PROJECT_TEAMS_REQUEST,
  fetchProjectsSuccess,
  fetchProjectsFailure,
  createProjectSuccess,
  createProjectFailure,
  updateProjectSuccess,
  updateProjectFailure,
  deleteProjectSuccess,
  deleteProjectFailure,
  assignUsersToProjectSuccess,
  assignUsersToProjectFailure,
  fetchProjectTeamsSuccess,
  fetchProjectTeamsFailure,
  removeProjectTeamsFailure,
  REMOVE_PROJECT_TEAMS_REQUEST,
} from '../actions/projectActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/agents`;
const token = localStorage.getItem('authToken');

function* fetchProjectsSaga(action) {
  try {
    const { page = 1, limit = 1, search = '' } = action.payload || {};
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search },
    });
    yield put(fetchProjectsSuccess(response.data)); // Payload includes `data` and `meta`
  } catch (error) {
    yield put(fetchProjectsFailure(error.message));
  }
}


function* createProjectSaga(action) {
  try {
    const response = yield call(axios.post, API_BASE_URL, action.payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(createProjectSuccess(response.data));
  } catch (error) {
    yield put(createProjectFailure(error.message));
  }
}

function* updateProjectSaga(action) {
  const { projectId, projectData } = action.payload;
  try {
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}`, projectData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(updateProjectSuccess(response.data));
  } catch (error) {
    yield put(updateProjectFailure(error.message));
  }
}

function* deleteProjectSaga(action) {
  try {
    yield call(axios.delete, `${API_BASE_URL}/${action.payload}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(deleteProjectSuccess(action.payload));
  } catch (error) {
    yield put(deleteProjectFailure(error.message));
  }
}

function* assignUsersToProjectSaga(action) {
  const { projectId, teamIds } = action.payload;
  try {
    yield call(
      axios.put,
      `${API_BASE_URL}/${projectId}/assign`,
      { teamIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const updatedProjectResponse = yield call(axios.get, `${API_BASE_URL}/${projectId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    yield put(assignUsersToProjectSuccess({
      projectId,
      newTeams: updatedProjectResponse.data.teams,
    }));
  } catch (error) {
    yield put(assignUsersToProjectFailure(error.message));
  }
}

function* fetchProjectTeamsSaga(action) {
  const projectId = action.payload;
  try {
    const response = yield call(
      axios.get,
      `${API_BASE_URL}/${projectId}/teams`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put(fetchProjectTeamsSuccess(response.data));
  } catch (error) {
    yield put(fetchProjectTeamsFailure(error.message));
  }
}

function* removeTeamFromProjectSaga(action) {
  const { projectId, teamIds } = action.payload;
  try {
    yield call(
      axios.delete,
      `${API_BASE_URL}/${projectId}/teams/${teamIds}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    yield put(removeProjectTeamsFailure(error.message));
  }
}

export default function* projectSaga() {
  yield takeLatest(FETCH_PROJECTS_REQUEST, fetchProjectsSaga);
  yield takeLatest(CREATE_PROJECT_REQUEST, createProjectSaga);
  yield takeLatest(UPDATE_PROJECT_REQUEST, updateProjectSaga);
  yield takeLatest(DELETE_PROJECT_REQUEST, deleteProjectSaga);
  yield takeLatest(ASSIGN_USERS_TO_PROJECT_REQUEST, assignUsersToProjectSaga);
  yield takeLatest(FETCH_PROJECT_TEAMS_REQUEST, fetchProjectTeamsSaga);
  yield takeLatest(REMOVE_PROJECT_TEAMS_REQUEST, removeTeamFromProjectSaga);
}
